<template>
  <UikitPageComponent
    :error="!data && error"
    :pending="!data && pending"
    @retry="getPageData"
  >
    <HomeGenderPage
      v-if="data"
      :gender="PrimaryPageType.FEMALE"
      :data="data"
      :loading="pending"
      @get-next-page="getNextPageData"
    />

    <BusinessSeoLinks
      v-if="seoBlockLinks"
      :links="seoBlockLinks"
    />
  </UikitPageComponent>
</template>

<script lang="ts" setup>
import { PrimaryPageType, SeoLinkGroupDto } from '~/restAPI/data-contracts';
import { AnalyticsEvents } from '~/types/analytics';

const { t } = useI18n();
const { $addEvent } = useNuxtApp();
const schemaOrg = useSchemaOrg();

useHead({
  title: `${t('pages.women.base.title')} – ${t('common.OskellyOnlineStore')}`,
  meta: [
    {
      name: 'description',
      content: t('pages.women.base.description'),
    },
  ],
  bodyAttrs: {
    class: 'oskelly-2_0 main-page',
  },
  script: [
    {
      type: 'application/ld+json',
      children: schemaOrg,
    },
  ],
});

const {
  data,
  error,
  pending,
  getPageData,
  getNextPageData,
} = useHomeGenderPage(PrimaryPageType.FEMALE);

const seoBlockLinks = computed(() => data?.value?.seoLinks?.contentList as SeoLinkGroupDto[]);

onMounted(() => {
  $addEvent(AnalyticsEvents.PageView);
});
</script>
